import React from "react";
import { Link } from "react-router-dom";
import "../Css/TermsConditions.css";

const TermsConditions = () => {
  return (
    <>
      {/* HERO SECTION */}

      <section className="terms-hero">
        <div className="terms-overlay">
          <div className="terms-hero-content">

            <h1>Terms & Conditions</h1>

            <p>
              <Link to="/">Home</Link> /{" "}
              <span className="active">Terms & Conditions</span>
            </p>

          </div>
        </div>
      </section>

      {/* PAGE CONTENT */}

      <section className="terms-page">

        <div className="terms-container">

          <p className="last-updated">
            Last Updated: {new Date().getFullYear()}
          </p>

          <p>
            Welcome to SVK Maid Service. By accessing or using our website and
            services, you agree to comply with and be bound by the following
            Terms and Conditions. Please read these terms carefully before using
            our services.
          </p>

          <h2>Acceptance of Terms</h2>

          <p>
            By using this website, you confirm that you accept these Terms and
            Conditions and agree to follow them. If you do not agree with any
            part of these terms, please do not use our website or services.
          </p>

          <h2>Services Provided</h2>

          <p>
            SVK Maid Service provides domestic help services including house
            maids, baby care, patient care, cooking assistance, drivers, and
            home cleaning services in Mumbai and nearby areas.
          </p>

          <p>
            Service availability may vary based on location, staff availability,
            and customer requirements.
          </p>

          <h2>User Responsibilities</h2>

          <ul>
            <li>Provide accurate information when contacting or booking services</li>
            <li>Use the website only for lawful purposes</li>
            <li>Respect the terms of service agreed during hiring</li>
          </ul>

          <h2>Service Agreements</h2>

          <p>
            Final service details including responsibilities, working hours,
            payment terms, and service duration will be discussed and agreed
            upon between the customer and SVK Maid Service before confirmation.
          </p>

          <h2>Payments</h2>

          <p>
            Service fees and charges will be communicated clearly before
            service confirmation. Customers are responsible for making timely
            payments as agreed during the service arrangement.
          </p>

          <h2>Limitation of Liability</h2>

          <p>
            SVK Maid Service works to provide reliable and verified domestic
            helpers. However, we are not liable for any indirect damages,
            disputes, or service interruptions that may occur beyond our
            reasonable control.
          </p>

          <h2>Website Content</h2>

          <p>
            All content on this website including text, images, logos, and
            branding is the property of SVK Maid Service and may not be copied,
            reproduced, or distributed without permission.
          </p>

          <h2>Changes to Terms</h2>

          <p>
            SVK Maid Service reserves the right to update or modify these Terms
            and Conditions at any time. Updates will be reflected on this page.
          </p>

          <h2>Contact Information</h2>

          <p>
            If you have any questions regarding these Terms and Conditions,
            please contact us:
          </p>

          <ul className="contact-info">

            <li>
              Phone :<a href="tel:+919152151180"> +91 91521 51180</a>
            </li>

            <li>
              Email :<a href="mailto:info@svkmaidservice.com"> info@svkmaidservice.com</a>
            </li>

            <li>
              Address : <a href="https://maps.app.goo.gl/xnkLDxDkgzgRDinx8" target="_blank" rel="noopener noreferrer">Shreepal Complex, 115, Mahatma Gandhi Rd, near sagar plaza, Kapol wadi, GhatkoparWest, Ghatkopar East, Mumbai, Maharashtra 400086
              </a>
            </li>

          </ul>

        </div>

      </section>
    </>
  );
};

export default TermsConditions;